module.exports = __webpack_public_path__ + "img/85.6.CODm.4e1dc011.png";